import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchRules } from '../services/api';
import { useAuth } from './AuthContext';

const AppContext = createContext(null);

const DEFAULT_RULES = {
  sampleAreaSqFt: 1,
  maxBlackSpotsPerSqFt: 5,
  maxBlackSpotDiameterMm: 5,
  minDistanceBetweenLargeSpotsCm: 8,
  largeSpotThresholdMm: 5,
  zeroToleranceDefects: ['wood_knot', 'color_stain', 'calender_spot'],
  targetDistanceCm: 15,
  distanceToleranceCm: 3,
};

export function AppProvider({ children }) {
  const { user, authDisabled } = useAuth();
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [meta, setMeta] = useState({
    grade: '',
    gram: '',
    paperWidth: '',
    operator: '',
    inspector: '',
    customerId: '',
    customerName: '',
    pdr: '',
    sizeW: '',
    sizeH: '',
    size: '',
  });

  useEffect(() => {
    let alive = true;
    fetchRules()
      .then((data) => {
        if (!alive || !data) return;
        setRules((prev) => ({ ...prev, ...data }));
      })
      .catch(() => {
      });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    if (authDisabled || !user?.name) return;
    setMeta((prev) => {
      if (prev.operator) return prev;
      return { ...prev, operator: user.name };
    });
  }, [user, authDisabled]);

  const value = useMemo(
    () => ({
      rules,
      setRules,
      meta,
      setMeta,
      user,
    }),
    [rules, meta, user]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppState() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppState must be used within AppProvider');
  return ctx;
}
